<template>
  <div class="formulate-input-element--checkbox-cards">
    <div
      v-for="option in fieldOptions"
      :key="option.value"
      class="formulate-input-element--checkbox-card"
      @click.prevent="toggle(option.value)"
    >
      <input
        type="checkbox"
        :id="`${context.id}-${option.value}`"
        :value="option.value"
        :checked="isChecked(option.value)"
        tabindex="-1"
        @click.prevent
      />
      <label :for="`${context.id}-${option.value}`" class="formulate-input-element--checkbox-card__label">
        <span class="formulate-input-element--checkbox-card__thumb">
          <img
            v-if="option.icon"
            :src="getAssetPath(option.icon, 'icons')"
            :alt="option.customLabel || option.label"
          />
        </span>
        <span class="formulate-input-element--checkbox-card__text">{{ option.customLabel || option.label }}</span>
      </label>
    </div>
  </div>
</template>

<script src="./FormulateCheckboxCards.js"></script>
